import { useEffect, useRef, useState } from "react";

const useIntersectionObserver = (options) => {
  const { threshold = 0.1, onIntersect } = options;
  const [isIntersecting, setIsIntersecting] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;

    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsIntersecting(true);
          if (onIntersect) onIntersect();
          observer.disconnect();
        }
      },
      { threshold }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [threshold, onIntersect]);

  return { elementRef, isIntersecting };
};

export default useIntersectionObserver;
